import styled from 'styled-components';
import { AdornmentMixin } from '../../mixins/components/AdornmentMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledAdornment = /*#__PURE__*/styled('label').withConfig({
  shouldForwardProp: doNotForwardTransientProp(['disabled', 'readOnly'])
}).withConfig({
  displayName: "StyledAdornment",
  componentId: "c11n-8-111-1__sc-1h2m3pa-0"
})(["", ""], AdornmentMixin);